/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetTrainerClipsParams,
  TrainWithMeModulesClipsDtosResponsesGetTrainerClipsResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTrainerClips = (
    params?: GetTrainerClipsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesGetTrainerClipsResponse>(
      {url: `/trainer/clips`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTrainerClipsQueryKey = (params?: GetTrainerClipsParams,) => {
    return [
    `/trainer/clips`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTrainerClipsQueryOptions = <TData = Awaited<ReturnType<typeof getTrainerClips>>, TError = ErrorType<unknown>>(params?: GetTrainerClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrainerClipsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainerClips>>> = ({ signal }) => getTrainerClips(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrainerClips>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrainerClipsQueryResult = NonNullable<Awaited<ReturnType<typeof getTrainerClips>>>
export type GetTrainerClipsQueryError = ErrorType<unknown>


export function useGetTrainerClips<TData = Awaited<ReturnType<typeof getTrainerClips>>, TError = ErrorType<unknown>>(
 params: undefined |  GetTrainerClipsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerClips>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainerClips>>,
          TError,
          Awaited<ReturnType<typeof getTrainerClips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrainerClips<TData = Awaited<ReturnType<typeof getTrainerClips>>, TError = ErrorType<unknown>>(
 params?: GetTrainerClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerClips>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainerClips>>,
          TError,
          Awaited<ReturnType<typeof getTrainerClips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrainerClips<TData = Awaited<ReturnType<typeof getTrainerClips>>, TError = ErrorType<unknown>>(
 params?: GetTrainerClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrainerClips<TData = Awaited<ReturnType<typeof getTrainerClips>>, TError = ErrorType<unknown>>(
 params?: GetTrainerClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrainerClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrainerClipsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






